var _defs, _rect, _g, _path, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _text17, _text18, _text19, _text20, _text21, _text22, _text23, _text24, _line56, _line57, _line58, _line59, _line60, _line61, _line62, _line63, _line64, _text25, _text26, _text27, _path2, _path3, _path4, _path5, _path6, _path7, _polygon, _polygon2, _polygon3, _text28, _text29, _text30;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBanka(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 635.17 881.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-5{fill:#243746;}.cls-2{clip-path:url(#clip-path);}.cls-10,.cls-3,.cls-9{fill:#cadb2a;}.cls-4{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.64px;}.cls-5,.cls-6{font-size:14px;}.cls-5{font-family:Poppins-ExtraBold, Poppins;}.cls-10,.cls-5,.cls-8,.cls-9{font-weight:800;}.cls-6,.cls-7,.cls-8{fill:#fff;}.cls-6{font-family:Poppins-Bold, Poppins;font-weight:700;}.cls-8{font-size:10.03px;}.cls-10,.cls-8,.cls-9{font-family:Poppins-BlackItalic, Poppins;font-style:italic;}.cls-9{font-size:20.51px;}.cls-10{font-size:37.85px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(19.95 19.92)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -14.17,
    y: -14.17,
    width: 623.62,
    height: 870.24
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.77,
    y: 5.74,
    width: 623.62,
    height: 870.24
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M615.22-17a2.88,2.88,0,0,0-2.89-2.88H-17A2.89,2.89,0,0,0-19.95-17v876a2.89,2.89,0,0,0,2.9,2.88H612.33a2.88,2.88,0,0,0,2.89-2.88Z",
    transform: "translate(19.95 19.92)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M413.26,267H552.75v44.9H413.26Zm-107.85,0H413.26v44.9H305.41Zm-86.1,0h86.1v44.9h-86.1ZM42.52,267H219.31v44.9H42.52Z",
    transform: "translate(19.95 19.92)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 62.47,
    y1: 331.42,
    x2: 62.47,
    y2: 286.94
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 282.09,
    y1: 331.42,
    x2: 282.09,
    y2: 286.94
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 388.81,
    y1: 331.42,
    x2: 388.81,
    y2: 286.94
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 62.05,
    y1: 331.84,
    x2: 282.1,
    y2: 331.84
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 62.05,
    y1: 286.94,
    x2: 282.1,
    y2: 286.94
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 62.47,
    y1: 376.32,
    x2: 62.47,
    y2: 332.26
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 282.09,
    y1: 331.84,
    x2: 572.7,
    y2: 331.84
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 282.09,
    y1: 286.94,
    x2: 572.7,
    y2: 286.94
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 282.09,
    y1: 376.32,
    x2: 282.09,
    y2: 332.26
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 388.81,
    y1: 376.32,
    x2: 388.81,
    y2: 332.26
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 572.7,
    y1: 376.32,
    x2: 572.7,
    y2: 286.94
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 62.05,
    y1: 376.74,
    x2: 282.1,
    y2: 376.74
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 62.47,
    y1: 421.22,
    x2: 62.47,
    y2: 377.16
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 282.09,
    y1: 376.74,
    x2: 389.07,
    y2: 376.74
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 282.09,
    y1: 421.22,
    x2: 282.09,
    y2: 377.16
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 388.81,
    y1: 376.74,
    x2: 573.12,
    y2: 376.74
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 388.81,
    y1: 421.22,
    x2: 388.81,
    y2: 377.16
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 572.7,
    y1: 421.22,
    x2: 572.7,
    y2: 377.16
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 62.05,
    y1: 421.64,
    x2: 282.1,
    y2: 421.64
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 282.09,
    y1: 421.64,
    x2: 389.07,
    y2: 421.64
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 388.81,
    y1: 421.64,
    x2: 573.12,
    y2: 421.64
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 62.47,
    y1: 466.12,
    x2: 62.47,
    y2: 422.06
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 282.09,
    y1: 466.12,
    x2: 282.09,
    y2: 422.06
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 388.81,
    y1: 466.12,
    x2: 388.81,
    y2: 422.06
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 572.7,
    y1: 466.12,
    x2: 572.7,
    y2: 422.06
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 62.05,
    y1: 466.54,
    x2: 282.1,
    y2: 466.54
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 282.09,
    y1: 466.54,
    x2: 389.07,
    y2: 466.54
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 388.81,
    y1: 466.54,
    x2: 573.12,
    y2: 466.54
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 62.47,
    y1: 511.02,
    x2: 62.47,
    y2: 466.96
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 282.09,
    y1: 511.02,
    x2: 282.09,
    y2: 466.96
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 388.81,
    y1: 511.02,
    x2: 388.81,
    y2: 466.96
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 572.7,
    y1: 511.02,
    x2: 572.7,
    y2: 466.96
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 62.05,
    y1: 511.44,
    x2: 282.1,
    y2: 511.44
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 62.47,
    y1: 555.92,
    x2: 62.47,
    y2: 511.86
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 282.09,
    y1: 511.44,
    x2: 389.07,
    y2: 511.44
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 282.09,
    y1: 555.92,
    x2: 282.09,
    y2: 511.86
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 388.81,
    y1: 511.44,
    x2: 573.12,
    y2: 511.44
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 388.81,
    y1: 555.92,
    x2: 388.81,
    y2: 511.86
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 572.7,
    y1: 555.92,
    x2: 572.7,
    y2: 511.86
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 62.05,
    y1: 556.34,
    x2: 282.1,
    y2: 556.34
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 62.47,
    y1: 600.82,
    x2: 62.47,
    y2: 556.77
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 282.09,
    y1: 556.34,
    x2: 389.07,
    y2: 556.34
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 282.09,
    y1: 600.82,
    x2: 282.09,
    y2: 556.77
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 388.81,
    y1: 556.34,
    x2: 573.12,
    y2: 556.34
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 388.81,
    y1: 600.82,
    x2: 388.81,
    y2: 556.77
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 572.7,
    y1: 600.82,
    x2: 572.7,
    y2: 556.77
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 62.05,
    y1: 601.24,
    x2: 282.1,
    y2: 601.24
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 62.47,
    y1: 645.72,
    x2: 62.47,
    y2: 601.67
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 282.09,
    y1: 601.24,
    x2: 389.07,
    y2: 601.24
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 282.09,
    y1: 645.72,
    x2: 282.09,
    y2: 601.67
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 388.81,
    y1: 601.24,
    x2: 573.12,
    y2: 601.24
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 388.81,
    y1: 645.72,
    x2: 388.81,
    y2: 601.67
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 572.7,
    y1: 645.72,
    x2: 572.7,
    y2: 601.67
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 62.05,
    y1: 646.15,
    x2: 282.1,
    y2: 646.15
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 282.09,
    y1: 646.15,
    x2: 572.7,
    y2: 646.15
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(142.04 314.73)"
  }, "BANKA ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(309.42 314.81)"
  }, "TAKSIT ")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(458.92 314.73)"
  }, "KO\u015EUL")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(69.43 360.76)"
  }, "\u0130\u015F Bankas\u0131")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(332.08 360.56)"
  }, "6")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(439.29 360.95)"
  }, "500 TL \xDCzeri")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(69.43 405.67)"
  }, "Yap\u0131 Kredi Bankas\u0131 ")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(331.84 405.67)"
  }, "3")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(439.29 405.67)"
  }, "500 TL \xDCzeri")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(69.43 450.58)"
  }, "Garanti Bankas\u0131")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(331.62 450.58)"
  }, "2")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(439.29 450.58)"
  }, "500 TL \xDCzeri")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(439.29 495.89)"
  }, "500 TL \xDCzeri")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(69.45 495.49)"
  }, "Akbank")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(332.08 495.49)"
  }, "2")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(69.45 540.39)"
  }, "Finansbank")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(332.08 540.39)"
  }, "2")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(439.29 540.39)"
  }, "500 TL \xDCzeri")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(69.45 585.3)"
  }, "Halk Bankas\u0131")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(332.08 585.3)"
  }, "2")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(439.29 585.3)"
  }, "500 TL \xDCzeri")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(69.45 630.21)"
  }, "Ziraat Bankas\u0131")), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(332.08 630.21)"
  }, "3")), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(437.81 630.21)"
  }, "500 TL \xDCzeri ")), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 572.7,
    y1: 691.06,
    x2: 572.7,
    y2: 647
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 62.47,
    y1: 691.06,
    x2: 62.47,
    y2: 647
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 62.05,
    y1: 646.15,
    x2: 282.1,
    y2: 646.15
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 282.09,
    y1: 646.15,
    x2: 389.07,
    y2: 646.15
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 282.09,
    y1: 690.63,
    x2: 282.09,
    y2: 646.58
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 388.81,
    y1: 646.15,
    x2: 573.12,
    y2: 646.15
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 388.81,
    y1: 690.63,
    x2: 388.81,
    y2: 646.58
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 62.05,
    y1: 691.06,
    x2: 282.1,
    y2: 691.06
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 282.09,
    y1: 691.06,
    x2: 572.7,
    y2: 691.06
  })), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(69.45 675.12)"
  }, "Vak\u0131fbank")), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(332.08 675.12)"
  }, "2")), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(437.81 675.12)"
  }, "500 TL \xDCzeri ")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M202.8,725.53a14.47,14.47,0,0,1-5-4l5-4.75a11.23,11.23,0,0,0,3.5,2.35,9.7,9.7,0,0,0,3.85.82,4.2,4.2,0,0,0,2.66-.64,1.89,1.89,0,0,0,.76-1.47q0-2-4.35-3.52a13.08,13.08,0,0,1-4.73-3,6.92,6.92,0,0,1-2-5.21,10.2,10.2,0,0,1,1-4.28,8.75,8.75,0,0,1,3.45-3.71,12.32,12.32,0,0,1,6.59-1.54,14.64,14.64,0,0,1,5.92,1.15,12.31,12.31,0,0,1,4.42,3.16l-4.95,5a12.54,12.54,0,0,0-2.66-1.72,7.26,7.26,0,0,0-3.18-.72,3.41,3.41,0,0,0-2.19.58,1.73,1.73,0,0,0-.72,1.39,2.1,2.1,0,0,0,.93,1.6,9.89,9.89,0,0,0,3,1.48,12.38,12.38,0,0,1,5.25,3.19,7,7,0,0,1,1.84,4.88,9.76,9.76,0,0,1-1.29,4.72,10.29,10.29,0,0,1-4,3.94,13.56,13.56,0,0,1-6.81,1.58A14.34,14.34,0,0,1,202.8,725.53Z",
    transform: "translate(19.95 19.92)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M222.51,726.32l6.2-29.12h11.63a10.86,10.86,0,0,1,4.87,1,7.31,7.31,0,0,1,3.13,2.86,8.43,8.43,0,0,1,1.07,4.29,11.24,11.24,0,0,1-1.53,5.55,12.2,12.2,0,0,1-4.46,4.48,12.92,12.92,0,0,1-6.84,1.76h-4.66L230,726.32ZM237,710.42a5.15,5.15,0,0,0,2.49-.59,4.49,4.49,0,0,0,1.66-1.54,3.48,3.48,0,0,0,.59-1.91,2.22,2.22,0,0,0-.8-1.78,3.26,3.26,0,0,0-2.12-.67h-4.08l-1.39,6.49Z",
    transform: "translate(19.95 19.92)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M256.41,725.33a10.71,10.71,0,0,1-4.51-4.43,14.09,14.09,0,0,1-1.57-6.83,17,17,0,0,1,2.25-8.41,18.13,18.13,0,0,1,6.23-6.53,16.24,16.24,0,0,1,8.8-2.49,14.57,14.57,0,0,1,6.92,1.56,10.7,10.7,0,0,1,4.52,4.49,14.35,14.35,0,0,1,1.58,6.9,16.76,16.76,0,0,1-2.26,8.34,18,18,0,0,1-6.23,6.47,16.36,16.36,0,0,1-8.82,2.48A14.62,14.62,0,0,1,256.41,725.33Zm12.31-6.81a9,9,0,0,0,3.22-3.39,9.53,9.53,0,0,0,1.18-4.69,7.38,7.38,0,0,0-.83-3.63,5.57,5.57,0,0,0-2.27-2.29,6.93,6.93,0,0,0-3.32-.78,8.32,8.32,0,0,0-4.46,1.27,9.12,9.12,0,0,0-3.22,3.44,9.81,9.81,0,0,0-1.19,4.77,7.09,7.09,0,0,0,.83,3.55,5.41,5.41,0,0,0,2.28,2.24,7.08,7.08,0,0,0,3.31.76A8.42,8.42,0,0,0,268.72,718.52Z",
    transform: "translate(19.95 19.92)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M305.55,711a11.82,11.82,0,0,1-4.6,4.13l3.21,11.18h-8L293.8,717c-.53,0-.94,0-1.23,0h-3l-2,9.29h-7.46l6.19-29.12h12a10.46,10.46,0,0,1,4.65,1A7.37,7.37,0,0,1,306.1,701a7.71,7.71,0,0,1,1.11,4.15A10.78,10.78,0,0,1,305.55,711ZM291,710.5h3.94a4.55,4.55,0,0,0,2.35-.63,4.9,4.9,0,0,0,1.68-1.61,3.67,3.67,0,0,0,.61-1.92,2.18,2.18,0,0,0-.76-1.78,2.92,2.92,0,0,0-1.94-.63h-4.49Z",
    transform: "translate(19.95 19.92)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M319.72,726.32h-7.46L317,704.14h-7.81l1.47-6.94h23.11l-1.47,6.94h-7.84Z",
    transform: "translate(19.95 19.92)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M338.22,726.32h-7.46L337,697.2h7.46Z",
    transform: "translate(19.95 19.92)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "371.36 746.23 379.68 746.23 399.95 710.37 391.58 710.37 371.36 746.23"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "416 723.85 417.43 717.11 399.64 717.11 394.24 726.67 390.07 746.23 411.55 746.23 412.98 739.5 398.96 739.5 400 734.63 410.71 734.63 412.04 728.39 401.33 728.39 402.3 723.85 416 723.85"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "375.04 717.11 367.1 717.11 371.12 740.77 377.23 729.95 375.04 717.11"
  })), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(191.57 232.35)"
  }, "Banka taksit bilgilerimizi a\u015Fa\u011F\u0131da bulabilirsiniz.")), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(203.05 271.06)"
  }, "Banka Taksit Bilgileri")), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    className: "cls-10",
    transform: "translate(255.68 122.92)"
  }, "SAYIN", /*#__PURE__*/React.createElement("tspan", {
    x: -119,
    y: 39.71
  }, "M\xDC\u015ETERiLERiMiZiN"), /*#__PURE__*/React.createElement("tspan", {
    x: -44.95,
    y: 79.42
  }, "D\u0130KKAT\u0130NE"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanka);
export default __webpack_public_path__ + "static/media/banka.955b5f3074802c2fbfedfbe3fa60f3bf.svg";
export { ForwardRef as ReactComponent };